<div
  class="sidenav"
  [ngStyle]="{ backgroundColor: appConfig.settings.main_color }"
>
  <ng-container *ngTemplateOutlet="sidenav"></ng-container>
</div>

<div
  class="mobile-header"
  [ngClass]="{ opened: showMobileMenu }"
  [ngStyle]="{
    background: !showMobileMenu
      ? appConfig.settings.main_color
      : 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),' +
        appConfig.settings.main_color
  }"
>
  <button class="menu-btn" (click)="toggleMobileMenu($event)">
    <mat-icon
      *ngIf="!showMobileMenu"
      svgIcon="custom:burger-menu"
      [ngStyle]="{ width: '26px', height: '26px' }"
    ></mat-icon>
    <mat-icon
      *ngIf="showMobileMenu"
      svgIcon="custom:menu-close"
      [ngStyle]="{ width: '26px', height: '26px' }"
    ></mat-icon>
  </button>
  <span class="title">{{ appConfig.settings.page_title }}</span>
  <button
    *ngIf="!showMobileMenu && showMobileMapButton"
    [ngClass]="{ active: showMapValue }"
    (click)="showMap()"
  >
    Map
  </button>
</div>

<div
  class="mobile-menu"
  [ngStyle]="{ backgroundColor: appConfig.settings.main_color }"
  [ngClass]="{ opened: showMobileMenu }"
>
  <ng-container *ngTemplateOutlet="sidenav"></ng-container>
</div>

<ng-template #sidenav>
  <div class="logo-container">
    <a [routerLink]="['/']" (click)="hideMobileMenu()">
      <img
        width="130"
        height="52"
        [src]="
          ToolsHelper.minLogoUrl(
            appConfig.configsUrl,
            appConfig.settings.logo
          ) +
          '?v=' +
          nowDate
        "
        alt="logo"
      />
    </a>
    <a class="title-link" [routerLink]="['/']" (click)="hideMobileMenu()">
      <span>{{ appConfig.settings.title }}</span>
    </a>
    <a
      *ngIf="appConfig.settings.link_to_main_site"
      class="main-site-link"
      [href]="appConfig.settings.link_to_main_site"
      target="_blank"
      (click)="hideMobileMenu()"
    >
      <span>{{ returnClearLink(appConfig.settings.link_to_main_site) }}</span>
    </a>
  </div>
  <nav>
    <a
      *ngIf="!clusterConfig?.is_places_hidden"
      [routerLink]="['/']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon
        svgIcon="custom:places"
        [ngStyle]="{ width: '30px', height: '30px' }"
      ></mat-icon>
      <span class="label" [translate]="'destination-page-tabs.tab-1'"></span>
    </a>
    <a
      *ngIf="!clusterConfig?.is_guides_hidden"
      [routerLink]="['/guides']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon
        svgIcon="custom:guides"
        [ngStyle]="{ width: '30px', height: '30px' }"
      ></mat-icon>
      <span class="label" [translate]="'destination-page-tabs.tab-2'"></span>
      <span
        class="count"
        *ngIf="counts.guides > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ counts.guides }}</i></span
      >
    </a>
    <a
      *ngIf="!clusterConfig?.is_events_hidden"
      [routerLink]="['/events']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon
        svgIcon="custom:events"
        [ngStyle]="{ width: '30px', height: '30px' }"
      ></mat-icon>
      <span class="label" [translate]="'destination-page-tabs.tab-3'"></span>
      <span
        class="count"
        *ngIf="counts.events > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ counts.events }}</i></span
      >
    </a>
    <a
      *ngIf="!clusterConfig?.is_passports_hidden"
      [routerLink]="['/passports']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon
        svgIcon="custom:passports"
        [ngStyle]="{ width: '30px', height: '30px' }"
      ></mat-icon>
      <span class="label" [translate]="'destination-page-tabs.tab-6'"></span>
      <span
        class="count"
        *ngIf="counts.passports > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ counts.passports }}</i></span
      >
    </a>
    <!--    <a-->
    <!--      *ngIf="false && !clusterConfig?.is_deals_hidden"-->
    <!--      [routerLink]="['/deals']"-->
    <!--      (click)="hideMobileMenu()"-->
    <!--      routerLinkActive="active"-->
    <!--      [routerLinkActiveOptions]="{ exact: true }"-->
    <!--    >-->
    <!--      <mat-icon-->
    <!--        svgIcon="custom:deals"-->
    <!--        [ngStyle]="{ width: '30px', height: '30px' }"-->
    <!--      ></mat-icon>-->
    <!--      <span class="label" [translate]="'destination-page-tabs.tab-4'"></span>-->
    <!--      <span-->
    <!--        class="count"-->
    <!--        *ngIf="counts.deals > 0"-->
    <!--        [ngStyle]="{ color: backgroundColor }"-->
    <!--        ><i>{{ counts.deals }}</i></span-->
    <!--      >-->
    <!--    </a>-->
    <a
      *ngIf="user && clusterConfig?.has_chatbot"
      [routerLink]="['/assistant']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon
        svgIcon="custom:assistant"
        [ngStyle]="{ width: '30px', height: '30px' }"
      ></mat-icon>
      <span class="label" [translate]="'destination-page-tabs.tab-5'"></span>
    </a>
  </nav>
  <div class="_nav-list">
    <a
      *ngFor="let page of staticPages"
      [routerLink]="['/static-pages', page.slug]"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      class="_static-page"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <span class="label">{{ page.shortTitle ?? page.title }}</span>
    </a>
  </div>
  <div class="user-section">
    <a
      *ngIf="user && !clusterConfig.is_passports_hidden"
      [routerLink]="['/your-passports']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <span class="label" [translate]="'your-passports'"></span>
      <span
        class="count"
        *ngIf="counts.yPassports > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ counts.yPassports }}</i></span
      >
    </a>
    <a
      *ngIf="user"
      [routerLink]="['/your-tickets']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <span class="label" [translate]="'your-tickets'"></span>
      <span
        class="count"
        *ngIf="counts.yTickets > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ counts.yTickets }}</i></span
      >
    </a>
    <a
      *ngIf="user"
      [routerLink]="['/your-plans']"
      (click)="hideMobileMenu()"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <span class="label" [translate]="'trip-plans-title'"></span>
      <span
        class="count"
        *ngIf="savedPlaces > 0"
        [ngStyle]="{ color: backgroundColor }"
        ><i>{{ savedPlaces }}</i></span
      >
    </a>
    <app-auth [wlMode]="true" [renderModal]="false"></app-auth>
  </div>
</ng-template>

<app-auth
  [wlMode]="true"
  [renderTrigger]="false"
></app-auth>
